import { IconButton } from "@circleco/compass/components/IconButton";
import type { Editor } from "@tiptap/core";

import { t } from "@/i18n-js/instance";
import { Tooltip } from "@/react/components/SettingsApp/CompassCompat/Tooltip";

interface ResourceLinkButtonProps {
  disabled?: boolean;
  editor: Editor | null;
}

export const ResourceLinkButton = ({
  disabled,
  editor,
}: ResourceLinkButtonProps) => (
  <Tooltip content={t("circle_ai_home.composer_resource_link_tooltip")}>
    <IconButton
      icon="hashtag"
      variant="ghost"
      size="sm"
      aria-label={t("circle_ai_home.resource_link")}
      disabled={disabled}
      onClick={() => editor?.chain().focus().insertContent("#").run()}
    />
  </Tooltip>
);
